// extracted by mini-css-extract-plugin
export default {"item":"MenuItem_item__XKT3B","link":"MenuItem_link__j3WLI"};